import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Auth.css';
import './Game.css';
import './VersionNotes.css';
import AuthLayeredCard from './AuthLayeredCard';
import AuthSelectionToolbar from './AuthSelectionToolbar';
import { authButtonStyle, authButtonSmallStyle } from '../constants/authStyles';
import { APP_VERSION, CHANGELOG, changelogText } from '../constants/versions';
import { tl } from '../utils/inlineI18n';
import { normalizeLanguage } from '../i18n/languages';

const SEEN_KEY = 'text2_seen_version';

const VersionList = ({ entries, lang }) => (
  <div className="version-list">
    {entries.map((entry) => (
      <div key={entry.version} className={`version-entry${entry.version === APP_VERSION ? ' version-entry--current' : ''}`}>
        <div className="version-entry-head">
          <strong>v{entry.version}</strong>
          <span>{entry.date}</span>
          {entry.version === APP_VERSION ? <em>{tl('Güncel', 'Current')}</em> : null}
        </div>
        <ul>
          {entry.items.map((item, i) => <li key={i}>{changelogText(item, lang)}</li>)}
        </ul>
      </div>
    ))}
  </div>
);

// Ana menüdeki "Sürüm Notları" sayfası: tüm sürümler ve farkları.
const VersionNotes = () => {
  const navigate = useNavigate();
  const { t: tc, i18n } = useTranslation('common');
  const lang = normalizeLanguage(i18n.language);
  useEffect(() => {
    try {
      localStorage.setItem(SEEN_KEY, APP_VERSION);
    } catch {
      /* yoksay */
    }
  }, []);
  return (
    <div className="auth-container auth-container--selection version-page">
      <AuthLayeredCard className="version-card">
        <AuthSelectionToolbar
          onBack={() => navigate('/game')}
          backLabel={tc('back')}
          buttonStyle={authButtonStyle}
          title={tl('Sürüm Notları', 'Version Notes')}
          subtitle={`${tl('Şu anki sürüm', 'Current version')}: v${APP_VERSION}`}
        />
        <VersionList entries={CHANGELOG} lang={lang} />
      </AuthLayeredCard>
    </div>
  );
};

// Yeni sürüm ilk açıldığında bir kez gösterilen güncelleme popup'ı.
export const VersionUpdatePopup = () => {
  const { i18n } = useTranslation('common');
  const lang = normalizeLanguage(i18n.language);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    try {
      if (localStorage.getItem(SEEN_KEY) !== APP_VERSION) setOpen(true);
    } catch {
      /* yoksay */
    }
  }, []);
  if (!open) return null;
  const close = () => {
    try {
      localStorage.setItem(SEEN_KEY, APP_VERSION);
    } catch {
      /* yoksay */
    }
    setOpen(false);
  };
  const latest = CHANGELOG.filter((e) => e.version === APP_VERSION);
  return (
    <div className="version-popup-backdrop" role="dialog" aria-modal="true">
      <div className="version-popup">
        <h3>🎉 {tl('Yeni Güncelleme', 'New Update')} — v{APP_VERSION}</h3>
        <VersionList entries={latest} lang={lang} />
        <button type="button" className="auth-button" style={authButtonSmallStyle} onClick={close}>
          {tl('Tamam', 'OK')}
        </button>
      </div>
    </div>
  );
};

export default VersionNotes;
